// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalControllerInfo, NormalControllerInfoT } from "./normal-controller-info";
import { ValuedControllerInfo, ValuedControllerInfoT } from "./valued-controller-info";

export enum ControllerInfoVariant {
  NONE = 0,
  NormalControllerInfo = 1,
  ValuedControllerInfo = 2,
}

export function unionToControllerInfoVariant(
  type: ControllerInfoVariant,
  accessor: (
    obj: NormalControllerInfo | ValuedControllerInfo,
  ) => NormalControllerInfo | ValuedControllerInfo | null,
): NormalControllerInfo | ValuedControllerInfo | null {
  switch (ControllerInfoVariant[type]) {
    case "NONE":
      return null;
    case "NormalControllerInfo":
      return accessor(new NormalControllerInfo())! as NormalControllerInfo;
    case "ValuedControllerInfo":
      return accessor(new ValuedControllerInfo())! as ValuedControllerInfo;
    default:
      return null;
  }
}

export function unionListToControllerInfoVariant(
  type: ControllerInfoVariant,
  accessor: (
    index: number,
    obj: NormalControllerInfo | ValuedControllerInfo,
  ) => NormalControllerInfo | ValuedControllerInfo | null,
  index: number,
): NormalControllerInfo | ValuedControllerInfo | null {
  switch (ControllerInfoVariant[type]) {
    case "NONE":
      return null;
    case "NormalControllerInfo":
      return accessor(index, new NormalControllerInfo())! as NormalControllerInfo;
    case "ValuedControllerInfo":
      return accessor(index, new ValuedControllerInfo())! as ValuedControllerInfo;
    default:
      return null;
  }
}

export type ControllerInfoVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalControllerInfo"; value: NormalControllerInfoT }
  | { type: "ValuedControllerInfo"; value: ValuedControllerInfoT };
